(() => {
  function init(config) {
    if(config.dataset.ready) return;
    const section=document.getElementById(config.dataset.section);
    const root=section?.querySelector('product-info');
    const info=root?.querySelector('.product__info-container');
    const media=root?.querySelector('.product__media-wrapper');
    if(!info || !media) return;
    config.dataset.ready='true';
    const text=JSON.parse(config.textContent);
    root.classList.add('ds-pdp-refined');
    if(!text.coherenceExcluded) root.classList.add('ds-pdp-coherent');
    const product=root.querySelector('.product');
    if(!root.querySelector('.ds-seasonal-header,.ds-pilot-heading') && !product?.classList.contains('ds-seasonal-pilot')) {
      const title=info.querySelector('.product__title');
      const rating=info.querySelector('[data-fera-container="product_reviews_summary"]')?.closest('.shopify-app-block') || info.querySelector('.rating-wrapper');
      const heading=document.createElement('div');
      heading.className='ds-pdp-mobile-heading';
      const positions=[title,rating].filter(Boolean).map(node=>{
        const anchor=document.createTextNode('');node.before(anchor);return {node,anchor};
      });
      const mq=matchMedia('(max-width:749px)');
      const layout=()=>{
        if(mq.matches){media.prepend(heading);positions.forEach(({node})=>heading.append(node));}
        else{positions.forEach(({node,anchor})=>anchor.after(node));heading.remove();}
      };
      layout();mq.addEventListener('change',layout);
    }
    const fitFor=value=>{
      const choice=(value||'').trim().toLowerCase();
      if(text.kind==='no_show') return text[choice] || '';
      if(text.kind==='dress' && (!choice || /^(default|default title|regular|[12347] (pair|pack))$/.test(choice))) return text.dress;
      if(text.kind==='unisex' && (!choice || /^(default|default title|regular|one size|one size fits all|[12347] (pair|pack))$/.test(choice))) return text.unisex;
      if(['kids','mixed_known','mixed_no_show','mixed_unisex'].includes(text.kind)) return text[text.kind];
      return '';
    };
    const applyFits=()=>{
      if(text.kind!=='no_show') return;
      info.querySelectorAll('variant-radios input[type="radio"],.ds-no-show-size input[type="radio"]').forEach(input=>{
        const label=input.closest('label') || info.querySelector(`label[for="${CSS.escape(input.id)}"]`);
        const range=text[input.value.toLowerCase()];
        if(!label || !range || label.querySelector('.ds-pdp-option-fit')) return;
        const small=document.createElement('small');small.className='ds-pdp-option-fit';small.textContent=range;
        (label.querySelector('span') || label).append(small);
        label.closest('ul')?.classList.add('ds-pdp-size-options');
      });
    };
    let fit=info.querySelector('.ds-pdp-fit');
    if(!fit && text.kind) {
      const target=info.querySelector('.product__sale-box__actions,.ds-set-picker');
      const value=fitFor(text.initial);
      const hasSizeOptions=info.querySelector('variant-radios input[type="radio"],.ds-no-show-size input[type="radio"]');
      if(target && value && !(text.kind==='no_show' && hasSizeOptions)){fit=document.createElement('p');fit.className='ds-pdp-fit';fit.textContent=value;target.before(fit);}
    }
    const member=info.querySelector(':scope > .ds-plus-note');
    const quality=info.querySelector('.ds-trust-box');
    if(member){
      const details=document.createElement('details');details.className='ds-pdp-member';
      const summary=document.createElement('summary');summary.textContent=text.member;
      member.before(details);details.append(summary,member);
      if(quality) quality.after(details);
      else info.querySelector('.product__trust-badges,.product__sale-box')?.after(details);
    }
    const setText=(node,value)=>{if(node.textContent!==value)node.textContent=value;};
    const enhancePurchase=()=>{
      if(text.coherenceExcluded) return;
      const trust=info.querySelector('.product__trust-badges');
      const review=info.querySelector('.ds-inline-review');
      if(review && trust && trust.nextElementSibling!==review)trust.after(review);
      if(!['accessory','gift_card','kids'].includes(text.kind) && !info.querySelector('.ds-seasonal-benefits,.ds-pdp-benefits')) {
        const sentence=[...info.children].find(node=>node.matches('p') && node.getAttribute('style')?.includes('letter-spacing:0.01em'));
        if(sentence) {
          const copy=sentence.textContent.trim();
          const points=copy==='Premium yarns and proprietary TrueStay™ grip for a comfortable, stay-put fit.'?text.dressBenefits:copy.split(/\.\s+/).map(x=>x.replace(/\.$/,'')).filter(Boolean);
          const list=document.createElement('ul');list.className='ds-pdp-benefits';list.setAttribute('aria-label',text.benefitsLabel);
          points.forEach(value=>{const li=document.createElement('li');li.textContent=value;list.append(li);});sentence.replaceWith(list);
        } else if(text.kind==='dress') {
          const target=info.querySelector('.product__price-block,.ds-set-picker,.product__sale-box');
          if(target){const list=document.createElement('ul');list.className='ds-pdp-benefits';list.setAttribute('aria-label',text.benefitsLabel);text.dressBenefits.forEach(value=>{const li=document.createElement('li');li.textContent=value;list.append(li);});target.before(list);}
        } else if(text.template==='sock-ankle') {
          const target=info.querySelector('.product__price-block,.ds-set-picker,.product__sale-box');
          if(target){const list=document.createElement('ul');list.className='ds-pdp-benefits';list.setAttribute('aria-label',text.benefitsLabel);text.ankleBenefits.forEach(value=>{const li=document.createElement('li');li.textContent=value;list.append(li);});target.before(list);}
        }
      }
      const picker=info.querySelector('ds-core-set-picker,ds-no-show-picker,ds-dress-pack-picker');
      let count=Number(text.pairCount),amount=null,variant=null,plan=null,target=null;
      if(picker && (picker.dataset.ready==='true' || picker.ready===true) && typeof picker.state==='function') {
        const state=picker.state();
        count=picker.matches('ds-dress-pack-picker')?Number(picker.dataset.count):picker.set==='core'?parseInt(picker.labels.pairs,10):1;
        if(state.recurring && !state.plan){const line=picker.querySelector('.ds-pdp-pack-value');if(line)line.hidden=true;return;}
        amount=state.recurring?state.plan.price:state.product.price;
        target=picker.querySelector('.buy-summary,[data-summary]');
        if(count>1 && target && Number.isFinite(amount)) {
          let line=picker.querySelector('.ds-pdp-pack-value');
          if(!line){line=document.createElement('p');line.className='ds-pdp-pack-value';target.after(line);}
          const money=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:state.product.currency||text.currency}).format(amount/count/100);
          setText(line,text.pairValue.replace('[count]',String(count)).replace('[price]',money));line.hidden=false;
        } else {const line=picker.querySelector('.ds-pdp-pack-value');if(line)line.hidden=true;}
        return;
      }
      if(picker)return;
      const form=info.querySelector('form[id^="product-form-"]');
      variant=text.packVariants?.find(x=>String(x.id)===form?.querySelector('[name="id"]')?.value);
      const planId=form?.querySelector('[name="selling_plan"]:not(:disabled)')?.value;
      if(!variant)return;
      plan=planId?variant.plans.find(x=>String(x.id)===planId):null;
      const widget=info.querySelector('recharge-subscription-widget');
      const lineText=planId?plan?.line:variant.line;
      target=widget?.closest('.recharge-subscription-widget') || info.querySelector('.product__price-block');
      let line=info.querySelector('.ds-pdp-pack-value');
      if(!target || !lineText || (widget && !root.classList.contains('ds-pdp-recharge-ready'))){if(line)line.hidden=true;return;}
      if(!line){line=document.createElement('p');line.className='ds-pdp-pack-value';line.setAttribute('aria-live','polite');target.after(line);}
      setText(line,lineText);line.hidden=false;
    };
    const sync=()=>{
      applyFits();
      const widget=info.querySelector('recharge-subscription-widget');
      const prices=widget?.shadowRoot?.querySelector('[part~="rc-purchase-option__prices"]');
      root.classList.toggle('ds-pdp-recharge-ready',!!prices?.textContent.trim());
      enhancePurchase();
    };
    sync();
    info.addEventListener('change',()=>requestAnimationFrame(sync));
    document.addEventListener('afterVariantChanged',sync);
    let pending=false;
    const observer=new MutationObserver(()=>{
      if(pending) return;
      pending=true;requestAnimationFrame(()=>{pending=false;sync();});
    });
    observer.observe(info,{childList:true,subtree:true});
    const widget=info.querySelector('recharge-subscription-widget');
    if(widget){
      customElements.whenDefined('recharge-subscription-widget').then(()=>{
        sync();if(widget.shadowRoot)observer.observe(widget.shadowRoot,{childList:true,subtree:true});
      });
    }
  }
  const boot=()=>document.querySelectorAll('[data-ds-pdp-refinements]').forEach(init);
  if(document.readyState!=='complete')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  document.addEventListener('shopify:section:load',boot);
})();

